import { useQuery } from "@tanstack/react-query";
import api from "../../http";

export const useGetUserOnline = () => {
    const query = useQuery({
        queryKey: ['online-user'],
        refetchInterval: 15_000,
        refetchIntervalInBackground: false,
        queryFn: async () => {
            const { data } = await api.get<{ onlineUsers: number }>('/user/online/count');
            return data.onlineUsers;
        },
    });

    return query;
};